export enum DrugSearchApiErrorCode {
  DRUG_SEARCH_NDC = 'DRUG_SEARCH_NDC',
  DRUG_SEARCH = 'DRUG_SEARCH',
  GEO_LOCATION_SEARCH = 'GEO_LOCATION_SEARCH',
  GET_PRICES_BY_PHARMACIES = 'GET_PRICES_BY_PHARMACIES',
  GET_PHARMACY_BY_NPI = 'GET_PHARMACY_BY_NPI',
}
